import LogRocket from 'logrocket';
import { useEffect } from 'react';
import { isEmptyObj } from '@app/utils/utils';

const useLogRocket = ({ flowConfig }) => {
  useEffect(() => {
    if (isEmptyObj(flowConfig)) return;

    const tracker = flowConfig.getTracker('LogRocket');
    if (!tracker) return;

    const id = tracker.getParamValue('id');
    const parentDomain = tracker.getParamValue('parentDomain');
    const rootHostname = tracker.getParamValue('rootHostname');

    LogRocket.init(id, {
      mergeIframes: true,
      parentDomain,
      rootHostname,
    });
  }, [flowConfig]);
};

export default useLogRocket;